import React from 'react';
import { Box, Grid } from '@material-ui/core';
import { AccordionSummary } from '@material-ui/core';
import { injectIntl, IntlShape } from 'react-intl';
import { get, isEmpty } from 'lodash';
import {
  FirstAccordion,
  StyledCaption,
  StyledSmallSectionHeader,
  StyledAccordionDetails,
} from 'components/AccordionFaq/styles';
import { useSelector } from 'react-redux';
import { AssuranceIcon } from 'images';
import SecondAccordionFaq from 'components/SecondAccordionFaq';
import { getSelectedFaqCodeSelector } from 'store/global/selectors';
import GaClickHOC from 'helpers/GATracking/GaClickHOC';

interface AccordionFaqType {
  intl: IntlShape;
  BgImage: string;
  IconTypeFaq: string;
  title: string;
  keyWord: string;
  faqDetails: { question: string; reponse: string; id: number }[];
  code: string;
  setSelectedFaq: Function;
}
const AccordionFaq = ({
  BgImage,
  IconTypeFaq,
  title,
  keyWord,
  faqDetails,
  code,
  setSelectedFaq,
  ...props
}: AccordionFaqType) => {
  const [expanded, setExpanded] = React.useState<string | false>(false);

  const handleChange = (panel: string) => (
    event: React.ChangeEvent<{}>,
    isExpanded: boolean,
  ) => {
    /* istanbul ignore next */
    setExpanded(isExpanded ? panel : false);
    setSelectedFaq({
      code: '',
      id: '',
    });
  };
  const expandSelectedFaq = useSelector(getSelectedFaqCodeSelector);
  return (
    <>
      <FirstAccordion
        aria-controls={`panel-content-1`}
        id={`panel-2`}
        data-testid={`panel-item-1`}
        expanded={
          !isEmpty(expandSelectedFaq) && expandSelectedFaq === code
            ? true
            : expanded === 'panel1'
        }
        onChange={
          !isEmpty(expandSelectedFaq)
            ? handleChange(expandSelectedFaq)
            : handleChange('panel1')
        }
        image={BgImage}
      >
        <AccordionSummary
          expandIcon={
            expanded === 'panel1' ||
            (!isEmpty(expandSelectedFaq) && expandSelectedFaq === code) ? (
              <img
                height="30px"
                width="30px"
                src={get(AssuranceIcon, 'openExpandFaq')}
                alt="question-faq-icon"
              />
            ) : (
              <img
                height="30px"
                width="30px"
                src={get(AssuranceIcon, 'expandFaq')}
                alt="question-faq-icon"
              />
            )
          }
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Box px={1} py={1} width="100%">
            <Grid container spacing={2}>
              <Grid item xs={2} sm={1}>
                <img
                  height="32px"
                  width="32px"
                  src={IconTypeFaq}
                  alt="auto-main-icon"
                />
              </Grid>
              <Grid item xs={10} sm={11}>
                <Grid container direction="column" spacing={2}>
                  <Grid item>
                    <StyledSmallSectionHeader>{title}</StyledSmallSectionHeader>
                  </Grid>
                  <Grid item>
                    <StyledCaption>{keyWord}</StyledCaption>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </AccordionSummary>

        <StyledAccordionDetails>
          <Grid container direction="column" spacing={2}>
            {faqDetails.map(
              (item: { question: string; reponse: string; id: number }) => (
                <GaClickHOC category={`FAQ_${code}`} label={item.question}>
                  <Grid item key={item.id}>
                    <SecondAccordionFaq
                      response={item.reponse}
                      question={item.question}
                      expanded={false}
                      id={item.id}
                      setSelectedFaq={setSelectedFaq}
                    />
                  </Grid>
                </GaClickHOC>
              ),
            )}
          </Grid>
        </StyledAccordionDetails>
      </FirstAccordion>
    </>
  );
};

export default injectIntl(AccordionFaq);
